import { createApiDescription } from "../../helperFunctions";

export const organizerUploadInfo = {
    batch: createApiDescription(
        "This API can be called to upload Multiple Organizers as a singular batch and submit it to the Organizers In-Process page.",
        [
          "Batch API only supports File URL format.",
          "User needs to provide the correct format of the zip file and csv file based on the tax software like with user interface upload.",
          "Engagement Letters need to be included inside the zip file only and it is optional.",
          "Batch API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once a request is sent from Batch API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    proforma: createApiDescription(
        "This API can be called to upload Organizers and submit it to the Organizers In-Process page.",
        [
            "Proforma API support both File URL format and base64 format.",
            "Engagement Letter can be included separately and are optional.",
            "Proforma API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once a request is sent from Batch API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
}
